import { render, staticRenderFns } from "./AdditionalQuestionsForm.vue?vue&type=template&id=d4f7172c&scoped=true"
import script from "./AdditionalQuestionsForm.vue?vue&type=script&lang=js"
export * from "./AdditionalQuestionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f7172c",
  null
  
)

export default component.exports